"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedErrorMessage = exports.ModalInput = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const Modals_style_1 = require("../Modals.style");
const ModalInput = ({ focusInputRef, value, onChange, name, type, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(Modals_style_1.TextInput, { type: type, name: name, ref: focusInputRef, value: value, onChange: onChange, placeholder: t("exportDataModal.emailPlaceholder") }));
};
exports.ModalInput = ModalInput;
const RedErrorMessage = styled_components_1.default.span `
  color: ${colors_1.red100};
`;
exports.RedErrorMessage = RedErrorMessage;
